import React from 'react';

/** Week view icon: 7 dots on a bar for days of the week. Use when calendar is in month view (click to switch to week). */
export function WeekViewIcon({ className, size = 20, ...props }: React.SVGProps<SVGSVGElement> & { size?: number }) {
  const dotPositions = [4, 8, 12, 16, 20, 24, 28];
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 32 24"
      fill="none"
      className={className}
      {...props}
    >
      {/* Bar */}
      <rect x="2" y="16" width="28" height="2.5" rx="1.25" fill="currentColor" />
      {/* 7 dots for week days */}
      {dotPositions.map((x, i) => (
        <circle key={i} cx={x} cy="10" r="2" fill="currentColor" />
      ))}
    </svg>
  );
}
